import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {GetFacebookIntegration as GetFacebookIntegrationQuery} from 'nutshell-graphql-types';

import GET_FACEBOOK_INTEGRATION from '../queries/get-facebook-integration.graphql';

export const useGetFacebookIntegration = () => {
    const {
        loading: isLoading,
        data,
        networkStatus,
        error,
        refetch,
        startPolling,
        stopPolling,
    } = useQuery<GetFacebookIntegrationQuery, Record<any, any>>(GET_FACEBOOK_INTEGRATION, {
        fetchPolicy: 'cache-and-network',
    });

    const facebookIntegration = data ? data.facebookIntegration : null;

    return {
        isLoading,
        isFirstLoad: isFirstLoad(networkStatus),
        facebookIntegration,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
